

import useToken from "../../hooks/useToken"
import { LineProgressBar, PagesTitleCtrl, ButtonCtrl, ModalMsgCtrl } from "./components"
import { Step } from "./steps"
import { GetLstPageTitle, catSumInsuredDolar, catSumInsuredColones, stepEnum } from "./data/MochaData"
import { usePage, useModal } from "./hook";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import { SiteConfig } from "./data/Data";
import './styles/Vida_cr.css'
import { DataContext, DataProvier } from "./data/DataContext";
import http from "../../services/http";
import { endPoints } from "../../utils/constanst";
import { GetResumenRate } from '../../utils/helpMain';
import {
    BuildDataOportunity,
    BuildDataNotificationOportunitySL,
    BuildDataPolicy,
    BuildPayment,
    BuildSaveCard,
    BuildNotification,
    BuildNotificationPol,
    BuildCardNum,
    GetHour,
    GetFormatMoneyFeePay
} from './data/Help'
import Modal from "react-modal";
import { IconWarning, IconSad } from './img'

const Vida = () => {
    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === 'opacity') {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade")
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <DataProvier loading={loading}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cr/vida" component={Layaout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layaout = ({ }) => {
    const page = usePage(SiteConfig.InitPage, GetLstPageTitle());
    const { vidaCR, setVidaCR, } = useContext(DataContext);
    const modalLoading = useModal({ isloading: true } as IModalProps);
    const modalMsg = useModal({ isloading: false } as IModalProps);
    const [modalNoValid, setModalNoValid] = useState(false);
    const [modalErrorPV, setModalErrorPV] = useState(false);
    const [modalErrorRate, setModalErrorRate] = useState(false);


    useEffect(() => {
        GetCatalogProvince();
    }, [])

    useEffect(() => {
        GetPlansConfiguration();
    }, [vidaCR.plan])

    useEffect(() => {
        GetRates();
    }, [vidaCR.nQuotas])

    useEffect(() => {
        if (ValidData(vidaCR.province))
            GetCatalogCanton();
        else
            setVidaCR({ ...vidaCR, catCanton: [], canton: '' })
    }, [vidaCR.province])

    useEffect(() => {
        if (ValidData(vidaCR.canton))
            GetCatalogDisctrict();
        else
            setVidaCR({ ...vidaCR, catDistrict: [], district: '' })
    }, [vidaCR.canton])

    useEffect(() => {
        if (ValidData(vidaCR.district))
            getCatalogNeighborhood();
        else
            setVidaCR({ ...vidaCR, catNeighborhood: [], neighborhood: '' })
    }, [vidaCR.district])


    const GetCatalogProvince = () => {
        modalLoading.setTextLoading('Cargando...');
        http(endPoints.department('506')).get()
            .then((x) => setVidaCR({
                ...vidaCR,
                catProvince: x, province: '',
                paymentPV: Payment,
                downloadPolicy: DownloadPolicy,
                finish: Finish,
                downloadReceipts: DownloadReceipts,
                viewFinishPage: ViewFinishPage
            }))
            .finally(() => modalLoading.hide())
    }

    const GetCatalogDisctrict = () => {
        modalLoading.setTextLoading('Cargando distrito...');
        http(endPoints.district('506', vidaCR.province, vidaCR.canton)).get()
            .then((x) => setVidaCR({ ...vidaCR, catDistrict: x, district: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetCatalogCanton = () => {
        modalLoading.setTextLoading('Cargando canton...');
        http(endPoints.country('506', vidaCR.province)).get()
            .then((x) => setVidaCR({ ...vidaCR, catCanton: x, canton: '' }))
            .finally(() => modalLoading.hide())
    }

    const getCatalogNeighborhood = () => {
        modalLoading.show('Cargando barrios...')
        http(endPoints.neighborhood('506', vidaCR.province, vidaCR.canton, vidaCR.district)).get()
            .then((x) => setVidaCR({ ...vidaCR, catNeighborhood: x, neighborhood: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetFees = () => {
        if (ValidData(vidaCR.plan)) {
            modalLoading.show();
            http(endPoints.fees(vidaCR.plan)).get()
                .then((x) => setVidaCR({ ...vidaCR, CatQuotas: x }))
                .finally(() => modalLoading.hide())
        }
        else
            setVidaCR({ ...vidaCR, nQuotas: '', catCuotas: [] })
    }

    const ValidateRequirements = (typeRisk: typeRisk, risk: string) => {
        let data = vidaCR.catInvalidRequirements.find(x => x.idMaestro === typeRisk.toString() && x.valor.toString() === risk.toString())
        if (data === null || data === undefined)
            return true
        return false
    }

    const GetPlansConfiguration = () => {
        if (ValidData(vidaCR.plan)) {
            modalLoading.show()
            Promise.allSettled([
                http(endPoints.fees(vidaCR.plan)).get(),
                http(endPoints.configPlan(2, vidaCR.plan)).get(),
                http(endPoints.coverages(vidaCR.plan)).get()
            ]).then(x => {
                let plan = {}
                let fees = []
                let coverAdd: Array<ICoveragesExt> = []
                let data: ICoveragesPlan = {} as ICoveragesPlan
                if (x[0].status === 'fulfilled')
                    fees = x[0].value.map((x: any) => { return { text: x.text, value: x.value, text2: x.description } as ICatalog });
                if (x[1].status === 'fulfilled')
                    plan = x[1].value;
                if (x[2].status === 'fulfilled') {
                    data = x[2].value;
                    data.coverages.map((cov: ICoverages) => {
                        coverAdd.push({ ...cov, type: 'DEFAULT', catalog: [] as Array<ICatalog>, checked: true } as ICoveragesExt)
                    });
                }
                setVidaCR({ ...vidaCR, catQuotas: fees, planConfig: plan, catCoverages: coverAdd, lstRateResumen: [], nQuotas: '' })
            }).finally(() => modalLoading.hide())
        }
        else
            setVidaCR({ ...vidaCR, nQuotas: '', catCuotas: [] })
    }

    const GetRates = () => {
        if (ValidData(vidaCR.nQuotas) && ValidData(vidaCR.plan)) {
            let lstSum: Array<ICatalog> = []
            let lstPromise: Array<Promise<any>> = []
            lstSum = vidaCR.plan === '611' ? catSumInsuredColones : catSumInsuredDolar;
            let errorRate = false;
            let messageErrorRate = ''

            modalLoading.show('Cargando planes...');

            lstSum.map(x => {
                const data = {
                    suma: x.value,
                    coverageIds: "[517,518,538]",
                    edad: vidaCR.age,
                    ncuotas: vidaCR.nQuotas
                };

                lstPromise.push(http(endPoints.tarificar(vidaCR.plan)).post(data));
            })

            Promise.allSettled(lstPromise).then(result => {
                let lst: Array<IRatesResumen> = [] as Array<IRatesResumen>;
                let lstRate: Array<IRatesLstVidaCR> = [] as Array<IRatesLstVidaCR>
                result.map((x: any, index: number) => {
                    if (x.status == 'fulfilled') {
                        const rates = x.value;
                        let resumen = GetResumenRate({
                            plan: vidaCR.planConfig,
                            catQuotas: vidaCR.catQuotas,
                            idDiscount: 0,
                            lstCoverageExt: vidaCR.catCoverages,
                            lstRates: rates["rates"] as Array<IRates>,
                            nQuotas: vidaCR.nQuotas,
                            sumInsured: lstSum[index].value
                        } as IPropsResumenRate)
                        lst.push(resumen);
                        const rate = { RateLst: rates["rates"] as Array<IRates> } as IRatesLstVidaCR
                        lstRate.push(rate)
                    }
                    else {
                        if (!errorRate) {
                            errorRate = true;
                            messageErrorRate = x.reason;
                        }

                    }
                    setVidaCR({ ...vidaCR, lstRateResumen: lst, lstRate: lstRate, errorRate: errorRate, messageErrorRate: messageErrorRate })
                })

                if (errorRate)
                    setModalErrorRate(true)
                modalLoading.hide();
            })//.finally(() => modalLoading.hide())

        }
    }

    const ValidData = (data: string) => (data !== null && data !== undefined && data !== '')

    const GetInitPersonalData2 = () => {
        modalLoading.show('Cargando...');
        Promise.allSettled([
            http(endPoints.catalog2('nacionalidad')).get(),
            http(endPoints.catalog2('profesion')).get(),
            http(endPoints.origenFondo('N')).get(),
            http(endPoints.catalog2('paises')).get(),
            http(endPoints.banks).get(),
            http(endPoints.catalogRiesgo).get()
        ]).then((x) => {
            let catNationality = []
            let catProfession = []
            let catOriginFunds = [] as Array<ICatalog>
            let catCountry = []
            let catBank = []
            let catInvalidRequirements: Array<ICatalogInvalidRequirements> = [];

            if (x[0].status === 'fulfilled')
                catNationality = x[0].value;
            if (x[1].status === 'fulfilled')
                catProfession = x[1].value;
            if (x[2].status === 'fulfilled')
                catOriginFunds = x[2].value;
            if (x[3].status === 'fulfilled')
                catCountry = x[3].value;
            if (x[4].status === 'fulfilled')
                catBank = x[4].value;
            if (x[5].status === 'fulfilled')
                catInvalidRequirements = x[5].value;


            setVidaCR({
                ...vidaCR,
                catNationality: catNationality,
                catProfession: catProfession,
                catOriginFunds: catOriginFunds,
                catCountry: catCountry,
                catBank: catBank,
                catInvalidRequirements: catInvalidRequirements,
            })
        }).finally(() => {
            modalLoading.hide();
            page.Increment();
        })
    }

    const SavePersonalData = () => {
        modalLoading.show("Validando correo...")
        http(endPoints.validateMail).post({
            correo: vidaCR.email,
            aplicacion: "Micro VidaCR"
        }).then(() => {
            modalLoading.show("Guardando...")
            page.Increment();
            const dataOportunity = BuildDataOportunity(vidaCR, '');
            Promise.allSettled([
                http(endPoints.createOportunityNew).post(dataOportunity),
                http(endPoints.sendNotficationNew).post(BuildNotification(vidaCR, 'BIENVENIDA'))
            ]).then((x) => {
                let createdOportunity = false
                let numOportunity = "";
                if (x[0].status === 'fulfilled') {
                    createdOportunity = true
                    numOportunity = x[0].value.message                   
                    setVidaCR({ ...vidaCR, oportunity: numOportunity, createdOportunity: createdOportunity })

                    const dataNotification = BuildDataNotificationOportunitySL(vidaCR)
                    dataNotification.values = { ...dataNotification.values, '{{oportunidad}}': x[0].value.message };
                    http(endPoints.sendNotificatioOportunitySL).post(dataNotification).finally(() => {
                        modalLoading.hide()
                        if (parseInt(vidaCR.age) >= 70)
                            page.ViewPage(stepEnum.StepFinishAge)
                        else
                            page.Increment()
                    });
                }
                else {
                    // modalLoading.hide()
                    // if (parseInt(vidaCR.age) >= 70)
                    //     page.ViewPage(stepEnum.StepFinishAge)
                    // else
                    //     page.Increment()

                    const dataNotification = BuildDataNotificationOportunitySL(vidaCR)
                    dataNotification.values = { ...dataNotification.values, '{{oportunidad}}': "-" };
                    http(endPoints.sendNotificatioOportunitySL).post(dataNotification).finally(() => {
                        modalLoading.hide()
                        if (parseInt(vidaCR.age) >= 70)
                            page.ViewPage(stepEnum.StepFinishAge)
                        else
                            page.Increment()
                    });
                }
            })

        }).catch(() => {
            modalLoading.hide();
            modalMsg.setTextMsgWithClose("Correo no valido");
        })
    }

    const SavePersonalData2 = () => {

        if (ValidateRequirements('nacionalidad', vidaCR.nationality) == false) {
            modalLoading.show('Validando...');
            http(endPoints.sendNotficationNew)
                .post(BuildNotification(vidaCR, 'NO_NACIONALIDAD', true))
                .finally(() => { setModalNoValid(true); modalLoading.hide(); return; })
        }
        else if (ValidateRequirements('profesion', vidaCR.profession) == false) {
            modalLoading.show('Validando...');
            http(endPoints.sendNotficationNew)
                .post(BuildNotification(vidaCR, 'NO_PROFESION', true))
                .finally(() => { setModalNoValid(true); modalLoading.hide(); return; })
        }
        else
            page.Increment();

        // if (!ValidateRequirements('nacionalidad', vidaCR.nationality) || !ValidateRequirements('profesion', vidaCR.profession))
        //     setModalNoValid(true)
        // else
        //     page.Increment();
    }

    const Payment = async (dataVida: IVidaCR) => {

        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;

        let idPayment = 0

        const info = {
            cnpoliza: '',
            statusAccount: '',
            transactionId: '',
            codigoAutorizacion: ''
        }

        let isErrorPV = false;

        try {
            // Muestra el modal de carga inicial
            modalLoading.show('Procesando pago...');

            // Construir datos del pago
            const data = BuildPayment(dataVida);

            // Hacer la primera solicitud (Pago)
            idPayment = await http(endPoints.paymentPay).post(data);

            // Mostrar mensaje de emisión de póliza
            modalLoading.show("Emitiendo póliza...");

            // Hacer la solicitud para obtener la emisión de la póliza
            const resEmision = await http(endPoints.emissions(data.policyId)).get();

            // Preparar datos para actualización de la póliza
            const dataUpdate = {
                idPayment: idPayment,
                cnpoliza: resEmision.policy
            };

            info.cnpoliza = idPayment.toString();

            // Mostrar mensaje de actualización de póliza
            modalLoading.show("Actualizando póliza...");

            // Hacer la solicitud para actualizar la póliza
            await http(endPoints.paymentUpdate2).put(dataUpdate);

            // Mostrar mensaje de aplicación de pago
            modalLoading.show("Aplicando pago...");

            // Hacer la solicitud para aplicar el pago
            const x = await http(endPoints.paymentApplyPayment(idPayment)).get();

            // Todo ha sido exitoso, ocultamos el modal y actualizamos el estado

            setVidaCR({
                ...dataVida,
                statusAccount: x.estadoCuenta,
                transactionId: x.transactionId,
                cnpoliza: resEmision.policy
            });
            
            info.cnpoliza = resEmision.policy;
            info.statusAccount = idPayment.toString();         
            info.codigoAutorizacion = x.codigoAutorizacion
            modalLoading.hide();
            // Llamamos al método de incremento de página


        } catch (error) {
            console.log(error);
            modalLoading.hide();
            setModalErrorPV(true);
            isErrorPV = true
            // Si algún paso intermedio falla, revertir el pago si es necesario
            if (error) {
                // try {
                //     await http(endPoints.paymentRevert(idPayment)).get();
                // } catch (revertError) {
                //     console.error("Error al revertir pago:", revertError);
                // }
            }
        }
        if (isErrorPV === false) {
            const dataNot = BuildNotification(dataVida, 'PAGO');
            let date = new Date();
            dataNot.values = {
                ...dataNot.values,
                '{{fechaTransaccion}}': date.toLocaleDateString('es-ES'),
                '{{horaTransaccion}}': GetHour(date),
                '{{poliza}}': info.cnpoliza,
                '{{numeroTarjeta}}': BuildCardNum(dataVida.cardNumber),
                '{{codAutorizacion}}': info.codigoAutorizacion,
                '{{montoPagado}}': GetFormatMoneyFeePay(dataVida),
            };
            modalLoading.show('Enviando correo...');
            http(endPoints.sendNotficationNew)
                .post(dataNot)
                .finally(() => { modalLoading.hide(); return; })
        }

        page.ViewPage(stepEnum.StepAutomaticPayment);
    }



    const SendNotificationErrorPV = () => {
        modalLoading.show('Enviando notificación...')
        http(endPoints.sendNotficationNew)
            .post(BuildNotification(vidaCR, 'NO_PAGO', true))
            .finally(() => { setModalNoValid(false); modalLoading.hide(); modalMsg.setTextMsgWithClose("Enviada") })
    }

    const SendNotificationPolicy = (data: IVidaCR) => {
        modalLoading.show('Enviando póliza...')
        http(endPoints.sendNotficationNew)
            .post(BuildNotificationPol(data, 'POLIZA'))
            .finally(() => {
                modalLoading.hide(); page.ViewPage(stepEnum.StepFinish);
            })
    }

    const SaveCard = () => {
        if (vidaCR.acceptSaveCard === 'S') {
            modalLoading.show('Actualizando datos...')
            http(endPoints.paymentUpdate).post(BuildSaveCard(vidaCR))
                .then(() => {
                    page.Increment();
                }).catch(() => {
                    page.Increment();
                }).finally(() => modalLoading.hide())
        }
        else
            page.Increment();
    }

    const DownloadPolicy = (id: string) => {
        modalLoading.show('Descargando póliza....')
        http(endPoints.descargarPoliza(id)).get()
            .catch(() => modalLoading.hide())
            .finally(() => {
                modalLoading.hide();
            })
    }

    const DownloadReceipts = (id: string) => {
        modalLoading.show('Descargando recibo...');
        http(endPoints.paymentReceipt(id, true))
            .getWithoutParam()
            .catch(() => modalLoading.hide())
            .finally(() => {
                modalLoading.hide();
            })
    }

    const ViewFinishPage = (data: IVidaCR) => SendNotificationPolicy(data)  // page.ViewPage(stepEnum.StepFinish);

    const CreatePolicy = () => {
        let pBenef: number = 0
        vidaCR.lstBeneficiary.map(x => {
            pBenef = pBenef + parseInt(x.percentage)
        })
        if (pBenef !== 100) {
            modalMsg.setTextMsgWithClose("El porcentaje total de beneficio debe ser igual al 100%. Favor revisar el dato ingresado en el formulario.")
            return
        }
        modalLoading.show('Creando oferta...')
        http(endPoints.createVida).post(BuildDataPolicy(vidaCR))
            .then(x => {
                setVidaCR({ ...vidaCR, polizaid: x.id, dateInit: x.fdesde, dateEnd: x.fhasta })
                http(endPoints.updateOportunityLogPolicy(vidaCR.oportunity, x.id)).get().finally(() => {
                    page.Increment();
                    modalLoading.hide();
                })
            }).catch(() => modalLoading.hide())
        //.finally(() => modalLoading.hide())
    }

    const Finish = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;

        if (window.top !== null && window.top !== undefined) {
            modalLoading.show();
            window.top.location.href = 'https://www.lafise.com/slcr/seguros/seguros-individuales/seguro-de-vida/solicitud-recibida';
        }
    }


    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;
        switch (page.index) {
            case stepEnum.StepPersonalData:
                SavePersonalData();
                break;
            case stepEnum.StepPlansCoverage:
                //CreatePolicy();
                if (vidaCR.errorRate)
                    setModalErrorRate(true)
                else
                    GetInitPersonalData2();
                break;
            case stepEnum.StepPersonalData2:
                SavePersonalData2()
                break;
            case stepEnum.StepBeneficiaries:
                CreatePolicy();
                break;
            case stepEnum.StepAutomaticPayment:
                SaveCard();
                break;
            // case stepEnum.StepPaymentCompleted:
            //     SendNotificationPolicy();
            //     break;
            default:
                page.Increment();
                break;

        }

    }

    const FinishNoValid = () => {
        setModalNoValid(false)
        modalLoading.show();
        window.location.reload();
    }

    const styleModal = {
        content: {
            border: "1px solid #E1E1E1",
            borderRadius: '2%',

        }, overlay: {
            backgroundColor: "rgba(255, 255, 255, 0.5)",

        }

    } as Modal.Styles

    return (
        <>
            <div className="container">
                <div className="layout-vida-cr">
                    <div className="mt-10">
                        <p className="lbl-title title-1">{page.actualPage.txtHead1}</p>
                        <p className="lbl-title title-2"> {page.actualPage.txtHead2}</p>
                    </div>
                    <LineProgressBar index={page.actualPage.indexBar} totalPages={SiteConfig.TotalPageBar} />
                    <form>
                        <div style={{ display: "flex" }}>
                            <div className="step-container-vida-cr">
                                <PagesTitleCtrl {...page.actualPage} />
                                <Step index={page.index} loading={modalLoading.modal.active} />
                            </div>
                        </div>
                        <ButtonCtrl data={page.actualPage} submit={Submit} back={page.Decrement} />
                    </form>
                </div>
            </div>
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
            <ModalMsgCtrl {...modalMsg.modal} closeModal={modalMsg.hide} />
            <Modal className="modal" isOpen={modalNoValid} style={styleModal} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >

                <div className="modal-body-info" style={{ textAlign: 'justify' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconWarning />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'justify', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        Por el momento no puede continuar con el proceso de emisión de su póliza.
                        Un ejecutivo de <strong>Seguros LAFISE</strong> se comunicará con usted lo antes posible.
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    {<button className="modal-btn-close" style={{ background: '#008866' }} onClick={(e) => { e.preventDefault(); FinishNoValid() }}>Cerrar</button>}
                </div>
            </Modal>
            <Modal className="modal" isOpen={modalErrorPV} style={{ overlay: { background: "rgba(255, 255, 255, 1)" } }} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >
                <div className="modal-body-info" style={{ textAlign: 'center' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <label className="lbl-title" style={{ color: '#FF0000', fontSize: '20px' }}>
                            ¡Ha ocurrido un error!
                        </label>
                    </div>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconSad />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        No hemos podido procesar su <br /> solicitud, actualice su método de pago <br /> o proporcione otro e inténtelo <br /> nuevamente.
                    </p>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        Si desea que un ejecutivo de Seguro <br /> LAFISE lo contante para continuar con <br /> la gestión via telefónica de clic en <br />
                        <strong> "Contáctenme"</strong>
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    <div>
                        <button className="modal-btn-close" style={{ background: '#EBEBEB', color: '#4D4D4D' }} onClick={(e) => { e.preventDefault(); setModalErrorPV(false) }}>Regresar</button>
                    </div>
                    <div>
                        <button className="modal-btn-close" style={{ background: '#008866' }} onClick={(e) => { e.preventDefault(); setModalErrorPV(false); SendNotificationErrorPV(); }}>Contáctame</button>
                    </div>
                </div>
            </Modal>

            <Modal className="modal" isOpen={modalErrorRate} style={{ overlay: { background: "rgba(255, 255, 255, 1)" } }} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >
                <div className="modal-body-info" style={{ textAlign: 'center' }}>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <label className="lbl-title" style={{ color: '#FF0000', fontSize: '20px' }}>
                            ¡Ha ocurrido un error!
                        </label>
                    </div>
                    <div className="mt-30" style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconSad />
                    </div>
                    <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'center', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
                        {vidaCR.messageErrorRate}
                    </p>
                </div>

                <div className="modal-footer mb-30">
                    <div>
                        <button className="modal-btn-close" style={{ background: '#EBEBEB', color: '#4D4D4D' }} onClick={(e) => { e.preventDefault(); setModalErrorRate(false) }}>Regresar</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default Vida;